function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13412",
  "data-name": "Path 13412",
  d: "M6.922,0H21V6l-5.15.582V13.6s-6.708.224-10.67-3.175S6.922,0,6.922,0Z",
  transform: "translate(1664 463)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "CHANGE_ROLE",
  "data-name": "CHANGE ROLE",
  transform: "translate(-1667.518 -450)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_14801",
  "data-name": "Group 14801",
  transform: "translate(-3223.483 -7217)"
}, /*#__PURE__*/React.createElement("g", {
  id: "how_to_reg-24px",
  transform: "translate(4891 7667)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13406",
  "data-name": "Path 13406",
  d: "M0,0H24V26H0Z",
  fill: "none",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_14799",
  "data-name": "Group 14799"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13407",
  "data-name": "Path 13407",
  d: "M11,12A4,4,0,1,0,7,8,4,4,0,0,0,11,12Zm0-6A2,2,0,1,1,9,8,2.006,2.006,0,0,1,11,6Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_14800",
  "data-name": "Group 14800",
  transform: "translate(-5649.517 -259)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13408",
  "data-name": "Path 13408",
  d: "M4,4A4,4,0,1,1,8,8,4,4,0,0,1,4,4ZM6,4A2,2,0,1,0,8,2,2.006,2.006,0,0,0,6,4Z",
  transform: "translate(5652.517 263)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_13410",
  "data-name": "Path 13410",
  d: "M11,16l4-4L11,8v3H5v2h6Z",
  transform: "translate(4900 7675)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_9",
  "data-name": "Mask Group 9",
  transform: "translate(0 -1)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_13411",
  "data-name": "Path 13411",
  d: "M7,16H0V14c0-2.557,4.925-3.894,7.678-3.994C7.785,10,7.891,10,8,10c2.67,0,8,1.34,8,4v2Z",
  transform: "translate(1670.518 455)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 2
})));

function SvgChangeRole(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeRole);
export default __webpack_public_path__ + "static/media/changeRole.dc44f62f.svg";
export { ForwardRef as ReactComponent };